import { Component, EventEmitter, Input, Output } from '@angular/core';

import { RankBonusViewModel } from './scorecard-rank.metadata';
@Component({
    selector: 'cmps-scorecard-rank-bonus',
    template: `
        <div
            class="cmps-scorecard-rank-bonus--container"
            *ngIf="isOpen"
        >
            <div class="cmps-scorecard-rank-bonus--top-section">
                <h5 class="cmps-scorecard-rank-bonus--top-label">
                    {{ label }}
                </h5>
                <button
                    class="cmps-scorecard-rank-bonus--close-btn"
                    (click)="closeAction.emit($event)"
                >
                    <cmps-icon svgIcon="__internal:close"></cmps-icon>
                </button>
            </div>
            <div class="cmps-scorecard-rank-bonus--bottom-section">
                <div
                    class="cmps-scorecard-rank-bonus--bottom-body"
                    *ngFor="let i of data"
                >
                    <p class="cmps-scorecard-rank-bonus--bottom-label">
                        {{ i.titleName }}
                    </p>
                    <p class="cmps-scorecard-rank-bonus--bottom-value">
                        {{ i.value }}
                    </p>
                </div>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-scorecard-rank-bonus',
    },
})
export class CmpsScorecardRankBonusComponent {
    @Input() label: string;
    @Input() data: RankBonusViewModel[];
    @Input() isOpen: boolean;

    @Output() closeAction: EventEmitter<MouseEvent | KeyboardEvent>;

    constructor() {
        this.closeAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.closeAction.complete();
    }
}
